module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question9.5c1ec3bd.jpg";